import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-sky-400 to-blue-500 rounded-xl p-3 md:p-4 text-white shadow-soft overflow-hidden min-w-0" }
const _hoisted_2 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-white/30 rounded w-16 mb-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-8 bg-white/30 rounded w-20 mb-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-white/30 rounded w-24" }, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1 text-white/80 text-sm mb-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Greenfield")
], -1)
const _hoisted_9 = { class: "flex items-center gap-2 md:gap-3" }
const _hoisted_10 = { class: "text-2xl md:text-3xl font-bold" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "text-white/80 text-xs md:text-sm capitalize truncate" }
const _hoisted_13 = { class: "flex gap-2 md:gap-3 mt-1 md:mt-2 text-xs text-white/70" }
const _hoisted_14 = {
  key: 2,
  class: "text-white/80 text-sm"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Weather unavailable", -1)
const _hoisted_16 = [
  _hoisted_15
]

import { ref, onMounted } from "vue";

interface WeatherData {
  temp: number;
  high: number;
  low: number;
  description: string;
  icon: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const weather = ref<WeatherData | null>(null);
const loading = ref(true);

const fetchWeather = async () => {
  // Greenfield, WI coordinates
  const lat = 42.9614;
  const lon = -88.0126;

  // Using OpenWeatherMap free tier
  const apiKey = process.env.VUE_APP_OPENWEATHER_API_KEY;

  if (!apiKey) {
    // Fallback to mock data if no API key
    weather.value = {
      temp: 72,
      high: 78,
      low: 61,
      description: "partly cloudy",
      icon: "02d",
    };
    loading.value = false;
    return;
  }

  try {
    const response = await fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=imperial&appid=${apiKey}`
    );
    const data = await response.json();

    weather.value = {
      temp: Math.round(data.main.temp),
      high: Math.round(data.main.temp_max),
      low: Math.round(data.main.temp_min),
      description: data.weather[0].description,
      icon: data.weather[0].icon,
    };
  } catch (error) {
    console.error("Failed to fetch weather:", error);
    // Fallback
    weather.value = {
      temp: 72,
      high: 78,
      low: 61,
      description: "partly cloudy",
      icon: "02d",
    };
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchWeather();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (weather.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(weather.value.temp) + "°F", 1),
              (weather.value.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `https://openweathermap.org/img/wn/${weather.value.icon}.png`,
                    alt: weather.value.description,
                    class: "w-8 h-8 md:w-10 md:h-10"
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(weather.value.description), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, "H: " + _toDisplayString(weather.value.high) + "°", 1),
              _createElementVNode("span", null, "L: " + _toDisplayString(weather.value.low) + "°", 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
  ]))
}
}

})